<template>
  <div class="container">
    <form @submit.prevent="submit" class="send-message-form">
      <div class="row py-1 px-2 align-content-center rounded-pill send-message-container">
        <textarea v-model="form.message" required class=" col-10 send-message-input"
                  :placeholder="$t(`chat.send_message_form.send_input_placeholder`)"/>

        <div class="col-2 p-0">
          <div class="d-flex align-content-center justify-content-end">
            <input ref="messageFiles" @change="handleFileChange" type="file" class="d-none" id="customFile">
            <label class="file-icon mx-1 my-auto select-file-icon text-muted" for="customFile"><i
                class="bi bi-paperclip"></i></label>
            <button type="submit" class="send-message-button py-2 px-3 rounded-pill"
                    v-t="`chat.send_message_form.send_button`"></button>
          </div>
        </div>
      </div>
      <m-captcha1 v-if="captcha_status" v-model="form.captcha_answer" class="col-4 mb-5"/>
    </form>
  </div>
</template>

<script>
import mCaptcha1 from "../../Captcha/Captcha1";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "SendMessage",
  components: {mCaptcha1},
  props: {
    wrapperRef: {},
    slug: {
      default: null
    },
    updateMode: {
      default: false
    },
    chatUsers: {
      default: []
    }
  },
  data() {
    return {
      form: {
        message: '',
        files: [],
        captcha_answer: '',
      },
      captcha_status: false,
    }
  },
  methods: {
    resetForm() {
      this.form.message = ''
      this.form.files = []
    },
    async submit() {
      const sendMessageForm = document.querySelector('.send-message-button')

      sendMessageForm.classList.toggle('disable')

      this.form.slug = this.slug

      this.form.files = this.$refs.messageFiles.files

      if (this.updateMode) {
        await this.wrapperRef.sendMessage(this.form)
            .then((res) => {
              this.resetForm()
              this.$emit('newMessage', res.data.data.data)
              this.captcha_status = res.data.data.captcha_status
              document.querySelector(`.send-message-container`).scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
              })
            })
            .catch((error) => {
              if (this.captcha_status) {
                this.$store.dispatch('Captcha/getCaptcha')
              }
              console.log(error);
            });
      } else {
        this.form.withoutState = true

        if (this.chatUsers.length > 0) {
          this.form.users = this.chatUsers
        } else {
          this.form.group = [
            {
              'group_type': 'tag',
              'group_id': findAttributeOnSiteInfo('general_chat_group')[0],
              'group_on': 'user',
            }
          ]
        }


        const res = await this.$store.dispatch('Chat/startNewChat', this.form)
        this.$emit('startNewChat', res)
      }

      sendMessageForm.classList.toggle('disable')


    },
    setCaptchaRequiredProperty() {
      if (this.captcha_status) {
        document.querySelector('.captcha-input').setAttribute('required', true)
      }
    },
    handleFileChange(event) {
      if (this.form.message.trim().length == 0) {
        let result = ''
        Object.entries(event.target.files).forEach(item => {
          result += item[1].name + ' '
        })
        this.form.message = result
        this.submit()
      }
    },
  },
  mounted() {
    this.setCaptchaRequiredProperty()
  },
  updated() {
    this.setCaptchaRequiredProperty()
  }
}
</script>

<style scoped>
.send-message-container {
  border: 1px solid #e6e6e6;
}

.send-message-input {
  width: 80%;
  height: 40px !important;
  border: none;
  outline: none;
  padding: 10px;
  font-size: 16px;
  background: transparent;
}

.send-message-button {

  border: none;
  outline: none;
  background-color: var(--primary);
  color: white;
  font-size: 16px;
}

.send-message-button.disable {
  background-color: var(--secondary);
}

.select-file-icon {
  font-size: 23px;
}
</style>